import React from 'react';
import { AggregatorKeys } from '../Aggregators';

interface AggregationDisplayProps {
  isAggregated?: boolean;
  agg?: string;
  timeGrain?: string;
  prefix?: string;
}

const AggregationDisplay: React.FC<AggregationDisplayProps> = ({
  isAggregated = false,
  agg,
  timeGrain,
  prefix,
}) => {
  if (isAggregated) {
    return (
      <span style={{ paddingTop: '4.5px', paddingRight: '2px' }} className="columnPrefix">
        Agg
      </span>
    );
  }

  return (
    <span style={{ paddingTop: '4.5px', paddingRight: '2px' }} className="columnPrefix">
      {agg ? AggregatorKeys[agg] : null}
      {agg && timeGrain ? <React.Fragment>, </React.Fragment> : null}
      {timeGrain ? AggregatorKeys[timeGrain] : null}
      {prefix ? `${prefix}` : null}
    </span>
  );
};

export default AggregationDisplay;
